let popup_type = "Ingresa tu comuna de envío";
// let popup_type = "Escoge tu sucursal de Chilexpress";
// let popup_type = "Selecciona tu tu tienda";

function headerEventClick (itemName) {
  dataLayer.push({
    event: "header_interactions",
    first_level: itemName
  });
}

function menuEventsClick (firstLevelItem, secondLevelItem = "", thirdLevelItem = "") {

  dataLayer.push({
    event: "menu_interactions",
    first_level: firstLevelItem,
    second_level: secondLevelItem,
    third_level: thirdLevelItem
  }); 
}

(function() {
  const handlerLoadPopup = () => {
    setTimeout(() => {
     
      $("#region-oms-location").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_region", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $("#region-oms-store").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_region", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $("#region-oms-chilexpress").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_region", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })




      $("#comuna-oms-location").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_comuna", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $("#comuna-oms-store").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_comuna", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $("#comuna-oms-chilexpress").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "selecciona_comuna", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $(".location .modal-footer .submit-location").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "clic_continuar", // Esto debe cambiar según la acción
          third_level: popup_type
        })
      })

      $(".breadcrumb .breadcrumb-item").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "continuar_comprando", // Esto debe cambiar según la acción,
          second_level: popup_type, // Esto debe cambiar según la acción
        })
      })

      $('.shipping-options-radio').on("click", (e) => {

        const type = e.target.value;

        let local = ""

       if (type == "Delivery") {
          popup_type = "Ingresa tu comuna de envío"
          local = "envio_a_domicilio"
       } else if (type == "Tienda") {
          popup_type = "Selecciona tu tu tienda"
          local = "retiro_en_tienda";
          dataLayer.push({
            event: "cart_interactions",
            first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
            second_level: "displayed", // Esto debe cambiar según la acción
            third_level: "Selecciona tu tu tienda"
          })
       } else if (type == "DeliverySuc") {
          popup_type = "Escoge tu sucursal de Chilexpress"
          local = "retiro_en_sucursal";
          dataLayer.push({
            event: "cart_interactions",
            first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
            second_level: "displayed", // Esto debe cambiar según la acción
            third_level: "Escoge tu sucursal de Chilexpress"
          })
       }

        dataLayer.push({
          event: "cart_interactions",
          first_level: "seleccionar_metodo", // Esto debe cambiar según la acción,
          second_level: local
        })

      })

      $('label[for="radioDeliveryES"]').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "velocidad_envio", // Esto debe cambiar según la acción,
          second_level: "Estandar", // Esto debe cambiar según la acción
        })
      })
      
      $('label[for="radioDeliveryEx"]').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "velocidad_envio", // Esto debe cambiar según la acción,
          second_level: "Express", // Esto debe cambiar según la acción
        })
      })

      $("#delivery-method").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "displayed", // Esto debe cambiar según la acción
          third_level: "Ingresa tu comuna de envío"
        })
      })

      $("#delivery-method-store").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "displayed", // Esto debe cambiar según la acción
          third_level: "Selecciona tu tienda"
        })
      })

      $("#delivery-method-chilexpress").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "displayed", // Esto debe cambiar según la acción
          third_level: "Escoge tu sucursal Chilexpress"
        })
      })

      $('.shipping-method-info .shipping-method-link > a').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "cambiar_destino", // Esto debe cambiar según la acción,
          second_level: "envio_a_domicilio", // Esto debe cambiar según la acción
        })
      })

      $('#agree').on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "tyc" // Esto debe cambiar según la acción,
        })
      })

      $('#go-to-checkout').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "ir_al_checkout", // Esto debe cambiar según la acción,
        })
      })

      $('.cart-shoping-item-body > .d-flex').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "product_click", // Esto debe cambiar según la acción,
        })
      })

      $('.cart-shoping-item-body > .d-flex').on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "product_click", // Esto debe cambiar según la acción,
        })
      })

      $(".qty-selector").on("change", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "cambiar_cantidad", // Esto debe cambiar según la acción,
        })
      })

      $(".close.cart__remove").on("click", () => {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "eliminar_producto", // Esto debe cambiar según la acción,
        })
      })

      /**
       * Popup loaded
       */
      const container = $(".modal-container.open");
      if (container.length) {
        dataLayer.push({
          event: "cart_interactions",
          first_level: "modal_region_y_comuna", // Esto debe cambiar según la acción,
          second_level: "displayed", // Esto debe cambiar según la acción
          third_level: "Ingresa tu comuna de envío"
        })
      };

    },2000)
  }

  handlerLoadPopup();
})()
